// extracted by mini-css-extract-plugin
export default {"hiddenInput":"GC8ZNj"};